import { createReducer } from '@reduxjs/toolkit';
import { LoadingStatuses } from 'core/common/entities';
import { fetchOffersFailed, fetchOffersPending, fetchOffersSucceed } from './actions/fetchOffers';
import { selectedOfferUpdated } from './actions/selectedOfferUpdated';
import { updateSelectedTrialOffer } from './actions/updateSelectedTrialOffer';
import { updateSelectedUpsell } from './actions/updateSelectedUpsell';
import { offersInitialState } from './state';

export const offersReducer = createReducer(offersInitialState, (builder) => {
  builder
    .addCase(fetchOffersPending, (state) => {
      state.loadingStatus = LoadingStatuses.PENDING;
    })
    .addCase(fetchOffersSucceed, (state, { payload }) => {
      state.entries = payload;
      state.loadingStatus = LoadingStatuses.FULFILLED;
    })
    .addCase(fetchOffersFailed, (state) => {
      state.loadingStatus = LoadingStatuses.FAILED;
    })
    .addCase(selectedOfferUpdated, (state, { payload }) => {
      state.selectedOffer = payload;
    })
    .addCase(updateSelectedUpsell, (state, { payload }) => {
      state.selectedUpsell = payload;
    })
    .addCase(updateSelectedTrialOffer, (state, { payload }) => {
      state.selectedTrialOffer = payload;
    });
});
